var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-renounce reversed",attrs:{"type":"button"},on:{"click":_vm.logout}},[_vm._v(_vm._s(_vm.$t('buttons.giveUp')))])}
var staticRenderFns = []

export { render, staticRenderFns }